module.exports = __webpack_public_path__ + "img/v3-risk-low.9d91b626.svg";